export const appConstant = {
    DEFAULT_LOADING_ERROR_MESSAGE: 'An error has occurred.',
    DEFAULT_SUBMIT_ERROR_MESSAGE: 'An error has occurred. Please try again later.',
    DEFAULT_SUBMIT_SUCCESS_MESSAGE: null,
    DEFAULT_IS_FIREBASE_SUPPORTED: 'isFirebaseSuported',
    DEFAULT_FIREBASE_SUPPORTED_TRUE: 'true',
    DEFAULT_FIREBASE_SUPPORTED_FALSE: 'false',
    YPO_PROD_ORIGIN: 'https://www.ypoconnect.org',
    YPO_IOS_CONNECT: 'iOSConnect',
    YPO_ANDROID_CONNECT: 'AndroidConnect',
    BROWSER_SUPPORT:
        'YPO Connect is best experienced on desktop or smartphone using Chrome or Safari. Some features may not display or function as intended on other devices or web browsers.',
    IS_SPEAKER_VIEW: 'IsSpeakerView',
    storageKeys: {
        eventDirectoryStoredFilters: 'eventDirectoryStoredFilters',
        memberDirectoryStoredFilters: 'memberDirectoryStoredFilters',
        connectionDirectoryStoredFilters: 'connectionDirectoryStoredFilters',
        followDirectoryStoredFilters: 'followDirectoryStoredFilters',
        communityDirectoryStoredFilters: 'communityDirectoryStoredFilters',
        contentDirectoryStoredFilters: 'contentDirectoryStoredFilters',
        ypoCookiesPolicyAccepted: 'ypoCookiesPolicyAccepted',
        impersonationKey: 'impersonation-key',
        ypoAttributionData: 'ypoAttributionData',
        ypoForwardToPostLogin: 'ypoForwardToPostLogin',
        ypoSfLoginToken: 'ypoSfLoginToken',
        loginRedirectModeTriggered: 'loginRedirectModeTriggered',
    },
    POLICY_AND_PROCEDURE_LINK:
        'https://www2.ypoconnect.org/topics/24644/media_center/folder/f3ef569f-e46c-45be-b900-30eb78b9f781',
    APP_VERSION_STATEMENT: 'The current version of your app is: ',
    SPEAKER_REGISTRATION:'https://airtable.com/appXYNdwp3H3FOs8u/pagjHOXoAZlagfnSQ/form',
    SPEAKER_RESOURCE_DIRECTORY:'https://yporesourcedirectory.ypo.org/'
};

export const routableComponents = {
    homePage: () => import('./components/HomePage/HomePage'),
    homeRightSidebar: () => import('./components/HomePage/HomeRightSidebar'),
    homeBanner: () => import('./components/HomePage/HomeBanner'),
    layout: () => import('./components/Layout/Layout'),
    header: () => import('./components/Header/Header'),
    login: () => import('./components/LoginPage/LoginPage'),
    chapterPage: () => import('./components/ChapterPage/ChapterPage'),
    chapterMain: () => import('./components/ChapterPage/chapterMain'),
    championMain: () => import('./components/ChampionsPage/ChampionsMain'),
    networkMain: () => import('./components/ChapterPage/NetworkMain'),
    allNetworksPage:() => import('./components/NetworkPage/AllNetworks.vue'),
    networkLandingPage:() => import('./components/NetworkPage/NetworkLandingPage.vue'),
    networkHeader:() => import('./components/NetworkPage/NetworkHeader.vue'),
    groupMain: () => import('./components/GroupPage/GroupMain.vue'),
    chapterRightSidebar: () => import('./components/ChapterPage/ChapterRightSidebar'),
    chapterLeftSideBar: () => import('./components/ChapterPage/ChapterLeftSideBar'),
    chapterBanner: () => import('./components/ChapterPage/ChapterBanner'),
    groupBanner: () => import('./components/GroupPage/GroupBanner.vue'),
    regionRightSidebar: () => import('./components/RegionPage/RegionRightSidebar'),
    forumRightSidebar: () => import('./components/ForumPage/ForumRightSidebar'),
    regionLeftSidebar: () => import('./components/RegionPage/RegionLeftSidebar'),
    forumLeftSideBar: () => import('./components/ForumPage/ForumLeftSideBar'),
    groupLeftSideBar: () => import('./components/GroupPage/GroupLeftSideBar'),
    groupRightSideBar: () => import('./components/GroupPage/GroupRightSideBar'),
    networkLeftSidebar: () => import('./components/NetworkPage/NetworkLeftSidebar'),
    homeLeftSidebar: () => import('./components/HomePage/HomeLeftSidebar'),
    networkRightSidebar: () => import('./components/NetworkPage/NetworkRightSidebar'),
    privacySettings: () => import('./components/MyAccount/PrivacySettings'),
    emailSettings: () => import('./components/MyAccount/EmailSettings'),
    manageLoginSecurity: () => import('./components/MyAccount/ManageLoginSecurity'),
    notification: () => import('./components/MyAccount/Notification'),
    myVisibility: () => import('./components/MyAccount/MyVisibility'),
    myProfile: () => import('./components/MyAccount/MyProfile'),
    memberProfile: () => import('./components/MemberProfile/MemberProfile'),
    memberDirectoryPage: () => import('./components/MemberDirectoryPage/MemberDirectoryPage'),
    ypoEvents: () => import('./components/YpoEvents/YpoEvents'),
    contentDirectoryPage: () => import('./components/ContentDirectoryPage/ContentDirectoryPage'),
    communityDirectoryPage: () => import('./components/CommunityDirectoryPage/CommunityDirectoryPage'),
    memberConnectionPage: () => import('./components/MemberConnectionsPage/MemberConnectionPage'),
    socialPage: () => import('./components/Social/SocialPage'),
    socialRightSidebar: () => import('./components/Social/SocialRightSidebar'),
    messengerPage: () => import('./components/InAppMessaging/MessengerPage/MessengerPage'),
    networkBanner: () => import('./components/NetworkPage/NetworkBanner'),
    appVersion: () => import('./components/AppVersion/AppVersion'),
    assistPage: () => import('./components/AssistPage/AssistPage'),
    chapterWaiver: () => import('./components/ChapterWaiver/ChapterWaiver'),
    peerReviewPanelAdmin: () => import('./components/ChapterWaiver/PeerReviewPanelAdmin'),
    peerReviewPanel: () => import('./components/ChapterWaiver/PeerReviewPanel'),
    regionalMemberOfficer: () => import('./components/ChapterWaiver/RegionalMemberOfficer'),
    chapterEvent: () => import('./components/ChapterEvent/ChapterEvent'),
    businesses: () => import('./components/Businesses/Businesses'),
    businessesLeftSidebar: () => import('./components/Businesses/BusinessesLeftSidebar'),
    businessesBanner: () => import('./components/Businesses/BusinessesBanner'),
    resourceDirectoryMain: () => import('./components/ResourceDirectory/ResourceDirectoryMain'),
    speakerProfile: () => import('./components/ResourceDirectory/SpeakerProfile'),
    searchSpeakers: () => import('./components/ResourceDirectory/SearchSpeakers'),
    speakerBanner: () => import('./components/ResourceDirectory/SpeakerBanner'),
    policiesProcedures: () => import('./components/PoliciesProcedures/PoliciesProcedures'),
    editSpeakerProfile: () => import('./components/ResourceDirectory/EditSpeakerProfile'),
    eventAttendees: () => import('./components/EventAttendees/EventAttendees'),
    errorPage: () => import('./components/YpoError/YpoError'),
    waiverForm: () => import('./components/ChapterWaiver/WaiverForm.vue'),
    waiverFormPRPAdmin: () => import('./components/ChapterWaiver/WaiverTileAdmin.vue'),
    waiverFormCommon: () => import('./components/ChapterWaiver/WaiverFormCommon.vue'),
    authenticateAndNavigate: () => import('./components/AuthenticateAndNavigate/AuthenticateAndNavigate'),
    resourceMenuPage: () => import('./components/YpoResources/YpoResources'),
    chapterStudioPage: () => import('./components/ChapterStudioPage/ChapterStudioPage'),
    manageChapterStudioPage: () => import('./components/ChapterStudioPageManage/ManageChapterStudio'),
    createChapterStudioAnnouncement: () => import('./components/ChapterStudioPageManage/CreateAnnouncement.vue'),
    communities: () => import('./components/Communities/Communities.vue'),
    communityBanner: () => import('./components/Communities/CommunityBanner.vue'),
    communityRightSideBar: () => import('./components/Communities/CommunityRightSidebar.vue'),
    communitiesLeftSidebar: () => import('./components/Communities/CommunitiesLeftSidebar.vue'),
};
